<template>
<div class="top">
      <mdb-carousel
    :interval="6000"
    slide
    :items="items"
    indicators
  ></mdb-carousel>
</div>
</template>

<style scoped>
/* 
    .items{
    height: 100px !important;
    max-width: 100% !important; 
    } */

    .top{
        margin-top: 145px;
    }
</style>
<script>
  import { mdbCarousel } from "mdbvue";
  export default {
    name: "CarouselPage",
    components: {
      mdbCarousel
    },
    data() {
      return {
        items: [
          {
            img: true,
            src:
              "https://firebasestorage.googleapis.com/v0/b/spdev-f487e.appspot.com/o/banner-web-1.png?alt=media&token=42e113a7-b6c2-435f-947c-60f06fb0ba1e",
          },
          {
            img: true,
            src:
              "https://firebasestorage.googleapis.com/v0/b/spdev-f487e.appspot.com/o/banner-web-digibaht.png?alt=media&token=8381fe9b-3f58-4bb6-b45e-06981fb5f9bd"
          },
          {
            img: true,
            src:
              "https://firebasestorage.googleapis.com/v0/b/spdev-f487e.appspot.com/o/banner-web-timemove.png?alt=media&token=f5aadf5a-1f4f-4a9b-8191-99cbb8ee5e4a"
          },
            {
            img: true,
            src:
              "https://firebasestorage.googleapis.com/v0/b/spdev-f487e.appspot.com/o/banner-web-news.png?alt=media&token=1de31c01-b47c-4ca2-ac41-7a7a6f29bd5f"
          },
        ]
      };
    }
  };
</script>
